import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';

export class GetVehicleMakesResponseExtensionClass implements IGetVehicleMakesResponse {
    public Makes: IVehicleMakes[];

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Makes = undefined;
        if (odataObject.Makes) {
            this.Makes = [];
            for (var i = 0; i < odataObject.Makes.length; i++) {
                if (odataObject.Makes[i]) {
                    if (odataObject.Makes[i]['@odata.type']) {
                        var className: string = odataObject.Makes[i]['@odata.type'];
                        className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
                        if ((EntityClasses as any)[className]) {
                            this.Makes[i] = new (EntityClasses as any)[className](odataObject.Makes[i]);
                        }
                    } else {
                        this.Makes[i] = new VehicleMakesExtensionClass(odataObject.Makes[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.Makes[i] = undefined;
                }
            }
        }
    }
}

export class VehicleMakesExtensionClass implements IVehicleMakes {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Id: number;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Name: string;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Id = odataObject.Id;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Name = odataObject.Name;
    }
}

export interface IGetVehicleMakesResponse {
    Makes?: IVehicleMakes[];
}

export interface IVehicleMakes {
    Id: number;
    Name?: string;
}

function vehicleMakesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function vehicleMakesInput(typeId: number): IDataServiceRequest {
    const query = vehicleMakesQuery();
    return query.createDataServiceRequestForOperation(
        'VehicleMakes',
        false,
        GetVehicleMakesResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'IGetVehicleMakesResponse' },
        {
            typeId: typeId
        }
    );
}

export function getVehicleMakesAsync(context: IContext, typeId: number): AsyncResult<IGetVehicleMakesResponse> {
    const request = vehicleMakesInput(typeId);
    return callActionOrExecute<IGetVehicleMakesResponse>(request, context.callerContext);
}
